import { render, staticRenderFns } from "./Communicator.vue?vue&type=template&id=c73cce58&scoped=true&"
import script from "./Communicator.vue?vue&type=script&lang=js&"
export * from "./Communicator.vue?vue&type=script&lang=js&"
import style0 from "./Communicator.vue?vue&type=style&index=0&id=c73cce58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73cce58",
  null
  
)

export default component.exports